import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { PrivateRoute } from 'components/common/PrivateRoute';
import { LoginPage } from 'components/login/LoginPage';
import { SignupPage } from 'components/login/SignupPage';
import { ResetPage } from 'components/login/ResetPage';
import { EulaPage } from 'components/eula/EulaPage';
import { PublicHomePage } from 'components/public/PublicHomePage';
import { ProgramListPage } from 'components/program/ProgramListPage';
import { ContentPage } from 'components/content/ContentPage';
import { ContentEditPage } from 'components/content/ContentEditPage';
import { ExternalLoginPage } from './components/login/External';
import { AccountPage } from 'components/account/AccountPage';
import { HomePage } from 'components/home/HomePage';
import AppDownload from 'components/redirects/AppDownload';

const Routes = () => {
	return (
		<Switch>
			<Route path='/redirect/app-download' component={AppDownload} />

			<PrivateRoute path='/account' component={AccountPage} />
			<PrivateRoute path='/programs' component={ProgramListPage} />
			<PrivateRoute path='/content/edit' component={ContentEditPage} />
			<PrivateRoute path='/content' component={ContentPage} />
			<PrivateRoute path='/home' component={HomePage} />

			<Route path='/eula/:lang' component={EulaPage} />
			<Route path='/login/external' component={ExternalLoginPage} />
			<Route path='/login' component={LoginPage} />
			<Route path='/signup' component={SignupPage} />
			<Route path='/reset/:region?/:token?' component={ResetPage} />
			<Route path='/reset' component={ResetPage} />

			<Route path='/' component={PublicHomePage} />
		</Switch>
	);
}

export default Routes;